import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../../modules/Svg';

/**
 * Table cell with "expand" icon
 *
 * @param {{}} props
 * @constructor
 */
const ExpandCell = props => (
    <a
        className="ui-link"
    >
        {!props.isExpanded &&
            <Svg size="Medium" iconName="down" />
        }
        {props.isExpanded &&
            <Svg size="Medium" iconName="up" />
        }
    </a>
);
ExpandCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * True for "collapse" icon and false for "expand" icon
     */
    isExpanded: PropTypes.bool,
};

export default ExpandCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/ExpandCell.js